import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { connect } from 'react-redux';

import { RootState } from 'redux/rootReducer';
import { loadFaq, shouldLoadFaq, IFaqState, setFaq } from 'redux/reducers/faq';
import userCanEdit from 'helpers/userCanEdit';
import useMedia from 'hooks/useMedia';

import {
  Content,
  Main,
  AccordionLayout,
  PrimaryButton,
} from './shared/FAQ.styles';
import { ReactComponent as IconPlus } from 'icons/icon-plus.svg';
import FAQAccordion from './FAQAccordion';
import { IFAQItem } from './shared/shared';
import Box from 'components/elements/Box';
import Modal from 'components/utility/Modal/Modal';
import CreateNewFAQModal from './CreateNewFAQModal';

interface IFAQComponentProps {
  loadFaq: () => void;
  shouldLoadFaq: () => boolean;
  setFaq: (data: any) => void;
  faq: IFaqState;
}

const FAQComponent: React.FC<IFAQComponentProps> = (props) => {
  const { loadFaq, shouldLoadFaq, faq } = props;
  const dispatch = useDispatch();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const isLargeScreen = useMedia('(min-width: 40em)');

  const { loading, data } = faq;

  const userCanChange =
    userCanEdit(
      useSelector((state: RootState) => state?.authentication?.profile)
    ) && isLargeScreen;

  useEffect(() => {
    if (shouldLoadFaq()) loadFaq();
  }, [shouldLoadFaq, loadFaq]);

  const saveNewFAQItem = (item: IFAQItem): void => {
    dispatch(setFaq([...data, item]));
  };

  return (
    <Main>
      <Content>
        <AccordionLayout>
          {userCanChange && (
            <Box mb={5}>
              <PrimaryButton onClick={(): void => setShowCreateModal(true)}>
                <IconPlus />
                Create New FAQ
              </PrimaryButton>
            </Box>
          )}
          <FAQAccordion
            isAdminRole={userCanChange}
            faqData={data}
            loading={loading}
            updateFaq={(newItems: IFAQItem[]): void =>
              dispatch(setFaq(newItems))
            }
          />
        </AccordionLayout>
        {showCreateModal && userCanChange && (
          <Modal
            maxWidth="960px"
            hide={(): void => setShowCreateModal(false)}
            canClickOutside={false}
          >
            <CreateNewFAQModal
              close={(): void => setShowCreateModal(false)}
              onSave={saveNewFAQItem}
            />
          </Modal>
        )}
      </Content>
    </Main>
  );
};

export default connect(
  (state: RootState) => ({
    faq: state.faq,
  }),
  {
    loadFaq,
    shouldLoadFaq,
    setFaq,
  }
)(FAQComponent);
